<div class="wrapper">
    <!-- <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar> -->
    <app-appli-side-bar [sidebars]="sidebar" (focusEventIndex)="setFocusIndex($event)" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar>


    <div class="icon_box">
        <div class="top_icon"></div>
        <div class="app_name">{{ appname }}</div>

    </div>
    <div class="remote_control"></div>
    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>
    <div class="main_content_wrapper">
        <div class="main_content">
            <!--レンタル品一覧-->
            <div *ngIf="rentalIndex == 0">
                <div class="rental_container">
                    <div class="rental_ul">
                        <div class="rental_icon" *ngFor="let item of rental">


                            <img [src]="item.icon_url" />
                            <div> {{ item.name }}</div>

                        </div>
                    </div>
                    <!-- 日本語 -->
                    <img src="/assets/icons/jpn/front.svg" *ngIf="lang == 'jpn'" class="frontimg">
                    <p class="smalltext" *ngIf="lang == 'jpn'"> ◆備品数には限りがございます。あらかじめご了承くださいませ。</p>
                    <!-- 英語 -->
                    <img src="/assets/icons/eng/front_eng.svg" *ngIf="lang == 'eng'" class="frontimg">
                    <p class="smalltext" *ngIf="lang == 'eng'"> ◆Please note that the number of items is limited.</p>
                </div>
            </div>
            <!--レンタサイクル-->
            <div *ngIf="rentalIndex == 1">

                <div class="floor_icon">
                    <img src="/assets/icons/com/floor.svg">
                </div>
                <div *ngIf="lang == 'jpn'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">レンタサイクル<span class="mess_l">（電動アシスト付き自転車）</span></div>

                            <div class="mess_l">
                                <p> 時間｜9:00 ～ 22:00<span class="smalltext">（最終返却時間）</span></p>
                                <p> 受付｜フロント</p>
                            </div>

                            <div class="mess_l">
                                <p>300円 / １時間　800円 / ３時間</p>
                                <p> 1,500円 / １日</p>
                            </div>

                            <div class="smalltext">
                                <p>※台数に限りがございます。</p>
                                <p>※子供用自転車のご用意はございません。</p>
                            </div>
                        </div>
                        <div class="right_img">
                            <img src="/assets/stay-info/rentalcycle.jpg">
                        </div>
                    </div>
                </div>
                <div *ngIf="lang == 'eng'">
                    <div class="rightzero_container">
                        <div class="divmessage">
                            <div class="mess_title">Bicycle Rental<span class="mess_l"> (Electric Bicycles)</span></div>
                            <div class="mess_l">
                                <p> 9:00 a.m. - 10:00 p.m.</p>
                                <p> 1F Front Desk</p>
                            </div>

                            <div class="mess_l">
                                <p>1 hour 300 yen　3 hours 800 yen</p>
                                <p>1 day 1,500 yen</p>
                            </div>

                            <div class="smalltext">
                                <p>※There is a limit to the number of bicycles available.</p>
                                <p>※Children's bicycles are not available.</p>
                            </div>
                        </div>
                        <div class="right_img">
                            <img src="/assets/stay-info/rentalcycle.jpg">
                        </div>
                    </div>
                </div>
            </div>

            <!--bluetoothについて-->
            <div *ngIf="rentalIndex == 2">
                <div *ngIf="lang == 'jpn'">
                    <div class="wakeupcall_box mess_title">
                        <p>モーニングコールの設定は客室電話より</p>
                        <img src="/assets/stay-info/morningcall.svg" class="morning_img">
                        <p>をダイヤルして下さい。</p>
                    </div>
                </div>
                <div *ngIf="lang == 'eng'">
                    <div class="wakeupcall_box mess_title">
                        <p> To setup wakeup-call, Dial</p>
                        <img src="/assets/stay-info/morningcall.svg" class="morning_img">
                        <p>with room telephone.</p>
                    </div>
                </div>
            </div>

            <!--マッサージ-->
            <div *ngIf="rentalIndex == 3">
                <img src="/assets/stay-info/inroom-spa.jpg" class="massage_imgs">
            </div>

            <!--レイトアウト-->
            <div *ngIf="rentalIndex == 4">
                <div *ngIf="lang == 'jpn'">
                    <div class="checkout_container">
                        <div class="checkout_box">
                            <p class="mess_title">１名 1,000円 / １時間</p>
                            <p class="mess_l">11：00 以降 13：00 まで</p>
                        </div>

                        <img src="/assets/icons/jpn/front.svg" class="frontimg">
                        <p class="smalltext">◆予約状況によりお受け出来ない場合もございます。</p>
                    </div>
                </div>

                <div *ngIf="lang == 'eng'">
                    <div class="checkout_container">
                        <div class="checkout_box">
                            <p class="mess_title">1,000 yen per hour after 11:00 a.m.</p>
                            <p class="mess_l">From 11:00 a.m. until 1:00 p.m.</p>
                        </div>

                        <img src="/assets/icons/eng/front_eng.svg" class="frontimg">
                        <p class="smalltext">◆We may not able accept your request depending on the situation.</p>
                    </div>
                </div>

            </div>




        </div>
    </div>
</div>